import { render, staticRenderFns } from "./summaryDetail.vue?vue&type=template&id=b34df718&scoped=true&"
import script from "./summaryDetail.vue?vue&type=script&lang=js&"
export * from "./summaryDetail.vue?vue&type=script&lang=js&"
import style0 from "./summaryDetail.vue?vue&type=style&index=0&id=b34df718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34df718",
  null
  
)

export default component.exports